import { groupByCategory, sumByCategory } from "./collectionUtils";

export const calculateAccountsPayable = (pnlData = {}) =>
  sumByCategory(
    (pnlData.expenses || []).filter((expense) => {
      const accountName = expense.account_name?.toLowerCase() || "";
      const category = expense.category?.toLowerCase() || "";

      return (
        accountName.includes("payable") ||
        accountName.includes("دائن") ||
        category.includes("payable") ||
        category.includes("مورد")
      );
    })
  );

export const calculatePayableTurnover = (pnlData = {}) => {
  const totalPayables = calculateAccountsPayable(pnlData);
  const cogs = sumByCategory(pnlData.cost_of_goods_sold || []);

  return totalPayables > 0 ? cogs / totalPayables : 0;
};

export const calculateDaysPayableOutstanding = (pnlData = {}) => {
  const turnover = calculatePayableTurnover(pnlData);
  return turnover > 0 ? 365 / turnover : 0;
};

export const groupPayablesByVendor = (payablesItems = []) => {
  const grouped = {};

  payablesItems.forEach((item) => {
    const vendor = item.vendor_name || item.account_name || item.description || "غير محدد";

    if (!grouped[vendor]) {
      grouped[vendor] = { totalAmount: 0, transactionCount: 0, items: [] };
    }

    grouped[vendor].totalAmount += item.amount || 0;
    grouped[vendor].transactionCount += 1;
    grouped[vendor].items.push(item);
  });

  return grouped;
};

export const analyzePayablesAging = (payablesItems = []) => {
  const aging = {
    current: 0,
    days31_60: 0,
    days61_90: 0,
    over90: 0,
  };

  const today = new Date();

  payablesItems.forEach((item) => {
    const dueDate = item.due_date || item.date || item.transaction_date;
    if (!dueDate) {
      aging.current += item.amount || 0;
      return;
    }

    const diffDays = Math.max(
      0,
      Math.floor((today - new Date(dueDate)) / (1000 * 60 * 60 * 24))
    );

    if (diffDays <= 30) {
      aging.current += item.amount || 0;
    } else if (diffDays <= 60) {
      aging.days31_60 += item.amount || 0;
    } else if (diffDays <= 90) {
      aging.days61_90 += item.amount || 0;
    } else {
      aging.over90 += item.amount || 0;
    }
  });

  return aging;
};

export const getPayablesDetails = (pnlData = {}, cashFlowData = {}) => {
  const payablesItems = (pnlData.expenses || []).filter((expense) => {
    const accountName = expense.account_name?.toLowerCase() || "";
    const category = expense.category?.toLowerCase() || "";

    return (
      accountName.includes("payable") ||
      accountName.includes("مورد") ||
      category.includes("payable") ||
      category.includes("مورد")
    );
  });

  return {
    totalPayables: calculateAccountsPayable(pnlData),
    payablesByVendor: groupPayablesByVendor(payablesItems),
    recentPayments: (cashFlowData.operating || [])
      .filter((item) => {
        const description = item.description?.toLowerCase() || "";
        return description.includes("مورد") || description.includes("vendor");
      })
      .slice(0, 10),
    agingAnalysis: analyzePayablesAging(payablesItems),
    byCategory: groupByCategory(payablesItems),
  };
};
